//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "@/components/common/header";
import Footer from "@/components/common/footer";
import Right from "@/components/common/Right";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name:'index',
 data () {
 return {
	 imghide:false,
	 experienceList: [],
	 groups: [
	   {  
	     title: '考研专业课',  
	     item: [ 
			 {label: '考试大纲',
			 description: '2025年管理类联考考研真题及解析（回忆版）',  
			 url: 'https://qiniuyun.51yantu.cn/20241223141128eb84f0361.jpg'},
	       {label: '考试大纲',  description: '2025年经济类联考考研真题及解析（回忆版2021_00',  
	       url: 'https://qiniuyun.51yantu.cn/2024122314235962cb21916.jpg'},{label: '考试大纲',  
	       description: '2025年中医综合考研真题及答案',  
	       url: 'https://qiniuyun.51yantu.cn/2024122314410208ab51426.jpg'},{label: '考试大纲',  
	       description: '2025年西医综合考研真题及答案',  
	       url: 'https://qiniuyun.51yantu.cn/20241223145605c4ff33794.jpg'}
	     ]
	   },  
	   {  
	     title: '考研英语',  
	     item:[ 
	       {label: '考试大纲',  
	       description: '2025年考研《英语一》真题及解析',  
	       url: 'https://qiniuyun.51yantu.cn/20241223131950117150444.jpg'},{label: '考试大纲',  
	       description: '2025年考研《英语二》真题及解析',  
	       url: 'https://qiniuyun.51yantu.cn/20241223132959ed76e5698.jpg'},{label: '考试大纲',  
	       description: '2024年考研《英语一》真题（1）',  
	       url: 'https://qiniuyun.51yantu.cn/20241223130831f79f65883.jpg'},{label: '考试大纲',  
	       description: '2024年考研《英语一》真题（2）',  
	       url: 'https://qiniuyun.51yantu.cn/202412231309176b56c1271.jpg'}
	     ] 
	   },  
	   {  
	     title: '考研数学',  
	     item:[ 
	       {label: '考试大纲',  
	       description: '2025年考研数学一真题及解析',  
	       url: 'https://qiniuyun.51yantu.cn/202412311530128f7781176.jpg'},{label: '考试大纲',  
	       description: '2025年考研数学二真题及解析',  
	       url: 'https://qiniuyun.51yantu.cn/2024123115291834d225943.jpg'},{label: '考试大纲',  
	       description: '2025年考研数学三真题及解析',  
	       url: 'https://qiniuyun.51yantu.cn/20241231152826d53c76386.jpg'},{label: '考试大纲',  
	       description: '2024年考研《数学（一）》真题',  
	       url: 'https://qiniuyun.51yantu.cn/2024070314585079db21718.jpg'} 
	     ]
	   },  
	   {  
	     title: '考研政治',  
	     item: [ 
	       {label: '考试大纲',  
	       description: '2025年考研政治真题及答案（1）',  
	       url: 'https://qiniuyun.51yantu.cn/202412231126135767a8173.jpg'},{label: '考试大纲',  
	       description: '2025年考研政治真题及答案（2）',  
	       url: 'https://qiniuyun.51yantu.cn/202412231127233902a4105.jpg'},{label: '考试大纲',  
	       description: '2024年考研《思想政治》真题',  
	       url: 'https://qiniuyun.51yantu.cn/20240606162250cf82b3379.jpg'},{label: '考试大纲',  
	       description: '2023年考研《思想政治》真题',  
	       url: 'https://qiniuyun.51yantu.cn/20240606173355e5f505649.jpg'}  
	     ]
	   }  
	 ],
	 interest1:false,
   catelist:[],
   timelive:[],//限时免费
   limit_course_list:[],
   mashangId:'',
    banners:[],
    swiperOption1: {
      notNextTick: true,
      autoplay: true,
      delay: 1500,
      loop: true,
      slidesPerView: "auto",
      centeredSlides: true,
      paginationClickable: true,
      // spaceBetween: 30,
      onSlideChangeEnd: swiper => {
      //这个位置放swiper的回调方法
      this.page = swiper.realIndex + 1;
      this.index = swiper.realIndex;
      },
      pagination: {
      el: ".swiper-pagination",
      }
    },
	swiperteacher: {
	  notNextTick: true,
	  autoplay: true,
	  delay: 1500,
	  loop: true,
	  slidesPerView: 3,
	  centeredSlides: true,
	  paginationClickable: true,
	  // spaceBetween: 30,
	  onSlideChangeEnd: swiper => {
	  //这个位置放swiper的回调方法
	  this.page = swiper.realIndex + 1;
	  this.index = swiper.realIndex;
	  },
	  pagination: {
	  el: ".swiper-pagination",
	  }
	},
	swiperteacher2: {
	  notNextTick: true,
	  autoplay: false,
	  loop: true,
	  slidesPerView:4 ,
	  paginationClickable: true,
	},
    numi:-1,
	numi1:-1,
    outline:[],//优质好课
    list:[],
    meng:false,
    liact:0,
    is_appointment:'',
    courselist:[],
	searchs:'',
	article_index:'',
	teacher:'',
	examList: [], // 考试练习列表
  }
 },
 mounted(){
	 this.$axios.post( `/v8/PC_index/number_two`).then(res => {
	     if(res.data.code == 200){
	 	  this.xcximg=res.data.data.xcx_img_url
	     }
	   })
    this.$axios.post('v8/index/getIndexNewTypeList').then(res=>{
      if(res.data.code==200){
        this.catelist=res.data.data;
		console.log(Array.from(this.catelist));
        Array.from(this.catelist).map((value,index)=>{
            Array.from(value.child).map((val,i)=>{
              if(i==0){
                  val.liact = true
				  
              }else{
                val.liact = false
              }
            })
        })
      }
    })
   //轮播图
    this.$axios.post(`/v8/PC_index/PC_index_banner`).then(res => {
      this.banners = res.data.data;
    });
  // 优质好课
  this.getoutline()
 //学长学姐
 this.getcourse()
 //师资
 this.getteacher()
 this.getExperienceList()
  this.$axios.post(`v8/index/getPcTypeList`).then(res => {
		console.log(res)
    if(res.data.code== 200) {
        this.list=res.data.data
    } else {
        this.$tips(res.data.msg);
    }
  })
  //获取新闻资讯
  this.$axios.post(`v9/index/article_index`).then(res => {
    if(res.data.code== 200) {
        this.article_index=res.data.data
    } else {
        this.$tips(res.data.msg);
    }
  })
  // 获取考试练习列表（固定3条）
  this.getExamList();
  
 },
 methods: {
	 getExperienceList() {
	 	    this.$axios.post('experience/list').then(res => {
			if (res.data.code === 200) {
			  // 适配接口返回的数据格式，映射为前端需要的字段
			  this.experienceList = res.data.data.list.map(item => ({
			    id: item.id,
			    title: item.title,
			    undergraduate: item.undergraduate, // 接口返回的本科专业
			    admission: item.admission, // 接口返回的录取专业
			    description: item.description, // 接口返回的简介
			    // 简易生成标签（也可以从接口返回，这里保持和原静态逻辑一致）
			    tags: ['上岸经验', item.undergraduate.substring(0, 2)],
			    link: `/experience/${item.id}`
			  }));
			} else {
			  this.$tips(res.data.msg || '获取上岸经验失败');
			}
		  })
		 },
	 	 // 修改4：新增上岸经验详情跳转方法（适配项目权限逻辑）
	 	 toExperienceDetail(id) {
	 	  if(!localStorage.getItem('IP') && !localStorage.getItem('TOKEN')){
	 	    this.$router.push('/ipts');
	 	    return false;
	 	  }
	 	  this.$router.push('/experienceDetail?id='+id);
	 	 },
	 
	
	selectOption(id) {
		if(!localStorage.getItem('IP') && !localStorage.getItem('TOKEN')){
			this.$router.push('/ipts');
			return false;
		}
		if(id == 15){
			if(localStorage.getItem('content') == '湘南学院'){
				window.location.href = 'https://www.yfzxmn.com';
			}else{
				this.$router.push('/examlist');
			}
			return
		}
		if(id == 2){
			window.location.href = 'http://www.dddjyky.com/AnalysisOfKy/index.php?Referrer=51yantu';
			return false;
		}
		if(id == 14){
			this.$router.push('/banji');
			return false;
		}
		if(id == 12){
			window.location.href = 'https://gpt.51yantu.cn/';
		 return false;
		}
		if(id == 13){
			this.$router.push('/material');
			return false;
		}else{
			this.$axios.get('/page/wanxue?wid='+id).then(res =>{
				window.location.href = res.data.data;
			})
		}
		
	   
	  },
	  prevSlide() {  
	        this.$refs.xsSwiper.swiper.slidePrev();  
	      },  
	      nextSlide() {  
	        this.$refs.xsSwiper.swiper.slideNext();  
	      },
	  download(url){
		  console.log(url)
	  		   window.open(url, '_blank');
	  },
	  getqcode(url){
	  		  this.imgcode = url 
	  		  this.imghide = true
	  },
	  hideqcode(){
	  		  this.imghide = false 
	  },
    changeli(index,i,id){
        this.catelist.map((value,valindex)=>{
			if(valindex==index){
				value.child.map((val,vali)=>{
				  if(vali==i){
					  val.liact = true
				  }else{
					val.liact = false
				  }
				})
			}
      })
      this.$axios.post('v8/index/getTypeCourseList',{type_id:id}).then(res=>{
        if(res.data.code==200){
          this.catelist[index].child_course.pagedata=res.data.data.pagedata
        }
      })
   },

   mashang(id){
        this.$axios.post(`/v9/Member/appointmentInsert`,{id:id}).then(res => {
          if(res.data.code==200){
              this.$tips(res.data.msg);
              this.getfree()
              this.is_appointment=1
          }else{
              this.$tips(res.data.msg);
          }
      });
    },
	//师兄师姐
	getcourse(){
	    this.$axios.post( `/banji/getBanjiList`,{page:this.page,sblei:0,limit:3}).then(res => {
	     if(res.data.code == 100){
					this.total = res.data.data.total
	         this.searchs=res.data.data.data
	     }
	   })
	},
	// 获取考试练习列表 limit=3
	getExamList() {
	  this.$axios.get("/pc/exam/list", {
	    params: {
	      page: 1,
	      limit: 4 // 固定只请求3条
	    }
	  }).then(res => {
	    if (res.data.code === 1) {
	      this.examList = res.data.data.data;
	    }
	  });
	},
	// 跳转到考试列表页（更多）
	toExamList() {
	  if(!localStorage.getItem('IP') && !localStorage.getItem('TOKEN')){
	    this.$router.push('/ipts');
	    return false;
	  }
	  this.$router.push("/examlist");
	},
	// 跳转到考试详情页
	toExamDetail(id) {
	  if(!localStorage.getItem('IP') && !localStorage.getItem('TOKEN')){
	    this.$router.push('/ipts');
	    return false;
	  }
	  this.$router.push(`/exam/detail?id=${id}`);
	},
   // 优质好课
    getoutline(){
      this.$axios.post(`/v4/index/featuredList`,{page:this.pagetotal2}).then(res => {
        if(res.data.code== 200) {
            this.outline=res.data.data;
        } else {
            this.$tips(res.data.msg);
        }
      })
    },
	//师资
	getteacher(){
		this.$axios.post( `/v9/index/getteacher`).then(res => {
		  if(res.data.code == 200){
				this.teacher = res.data.data
				console.log(this.teacher);
		  }
		})
	},
    through(id,type){
        if(type==2){
          this.$router.push("goodsDetail?id="+id)
        }else if(type==3){
          this.$router.push("zhuanlan?id="+id)
        }else{
          this.$router.push("videoDetail?id="+id)
        }
    },
    changenum(a){
      this.numi=a
	  if(!this.meng){
		 this.meng=true 
	  }
    },
	changenum1(a){
	  this.numi1=a
	},
    leave(){
      this.meng=false
    },
    // leaveli(){
    //   this.numi=-1
    // },
	leaveli1(){
		this.numi1=-1
	},
    toPage(a){
		if(!localStorage.getItem('IP') && !localStorage.getItem('TOKEN')){
			this.$router.push('/ipts');
			return false;
		}
      this.$router.push(a)
    }
 },

 created () {
 },
 components: {
    Header,
    Footer,
    Right,
    swiper,
    swiperSlide,
  }
}



// WEBPACK FOOTER //
// ./src/components/index/index.vue